// helpers.js
export const formatNumberAsEuro = (number, fractionDigits = 2) => {
    // Eerst controleren of de invoer een string is en deze correct omzetten
    if (typeof number === 'string') {
        number = number.replace('.', '').replace(',', '.');
        number = parseFloat(number);
    }

    // Controleer op geldig getal
    if (isNaN(number)) {
        return '€ 0,00';
    }

    // Check op negatief getal
    let isNegative = number < 0;


    // Verkrijgen van het integer gedeelte
    let integerPart = Math.floor(Math.abs(number));

    // Verkrijgen van het decimale gedeelte
    let decimalPart = Math.abs(number) - integerPart;
    decimalPart = decimalPart.toFixed(fractionDigits).split('.')[1];


//    decimalPart = decimalPart.replace(/0+$/, ''); 

    // Ensure at least two decimal places for currency format (e.g., "21,00")
    if (decimalPart.length < 2) {
        decimalPart = decimalPart.padEnd(2, '0');
    }
    // Altijd een positief getal
    integerPart = Math.abs(integerPart);

    // convert integer part to string
    integerPart = integerPart.toString();

    // Duizendtalpunten toevoegen
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');



    // Europees formaat
    let europeanFormat = `€ ${integerPart},${decimalPart}`;

    // Minusteken voor negatieve getallen
    if (isNegative) {
        europeanFormat = `- ${europeanFormat}`;
    }

    //console.log(europeanFormat);

    return europeanFormat;
}


export const parseEuropeanNumber = (numberString) => {
    if (!numberString) {
        return null;
    }
    const noThousandsSeparator = numberString.replace(/\./g, '');
    const standardDecimalSeparator = noThousandsSeparator.replace(/,/, '.');
    return parseFloat(standardDecimalSeparator);
}

// Toevoegen of verfijnen van overige helperfuncties, indien nodig.

export const formatCurrency = (value) => {
    // strip whitespace
    value = value.toString().replace(/\s/g, '');
    // // Remove periods and replace the last comma with a period for correct parsing.
    // let stringValue = value.toString().replace(/\./g, '').replace(/,(\d{2})$/, '.$1');
    // let numberValue = parseFloat(stringValue);

    // if (isNaN(numberValue)) {
    //     return 'Invalid number'; // Or handle the error as you see fit
    // }

    // // Format the number as a string with two decimal places.
    // let formattedValue = numberValue.toFixed(2);

    // // Check if the original string had a comma before the last two digits.
    // if (/,(\d{2})$/.test(value)) {
    //     // Replace the period with a comma for European style formatting.
    //     formattedValue = formattedValue.replace('.', ',');
    // }
    // if the value string contains a minus sign, it is a negative number
    if (value.includes("-")) {
        // Format the negative number with the euro sign before the number.
        return `-€${value}`;
    } else {
        // Format the positive number with the euro sign before the number.
        return `€${value}`;
    }
}





